import type {
	CreateHotelPromoBody,
	HotelOption,
	HotelPromo,
	ListHotelPromosParams,
	UpdateHotelPromoBody,
} from "@/features/hotel-promos/types";
import { api } from "@/shared/api/client";

function promoSearchParams(params: ListHotelPromosParams): URLSearchParams {
	const search = new URLSearchParams();
	const term = params.search?.trim();
	if (term && term.length >= 3) {
		search.set("search", term);
	}
	if (params.isActive !== undefined) {
		search.set("isActive", String(params.isActive));
	}
	return search;
}

export async function listHotelPromos(
	params: ListHotelPromosParams = {},
): Promise<HotelPromo[]> {
	return api
		.get("admin/hotel-promos", { searchParams: promoSearchParams(params) })
		.json();
}

export async function listHotelPromoHotels(): Promise<HotelOption[]> {
	return api.get("admin/hotel-promos/hotels").json();
}

export async function createHotelPromo(
	body: CreateHotelPromoBody,
): Promise<HotelPromo> {
	return api.post("admin/hotel-promos", { json: body }).json();
}

export async function updateHotelPromo(
	id: string,
	body: UpdateHotelPromoBody,
): Promise<HotelPromo> {
	return api.patch(`admin/hotel-promos/${id}`, { json: body }).json();
}

export async function deleteHotelPromo(id: string): Promise<void> {
	await api.delete(`admin/hotel-promos/${id}`);
}

export const hotelPromoKeys = {
	all: ["admin-hotel-promos"] as const,
	hotels: ["admin-hotel-promos", "hotels"] as const,
	list: (params: ListHotelPromosParams) =>
		["admin-hotel-promos", "list", params] as const,
};
